import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import {
  Card,
  Typography,
  Avatar,
  Tooltip
} from '@material-ui/core';
import CheckIcon from '@material-ui/icons/Check';
import { BtnApagar, BtnDuplicar, BtnEditar, BtnEliminar, BtnEncender } from '../../general/BotonesAccion';

const useStyles = makeStyles((theme) => ({
  card: {
    padding: '8px 14px 14px 14px',
    borderRadius: 14,
    backgroundColor: '#ffffff',
    border: '1px solid #ededed',
    transition: 'all .2s ease',
    '&:hover': {
      boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
    }
  },
  toolbar: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 12,
    marginBottom: 6,
  },
  header: {
    display: 'flex',
    alignItems: 'flex-start',
  },
  left: {
    display: 'flex',
    gap: 10,
  },
  avatar: {
    backgroundColor: '#F07256',
    width: 34,
    height: 34,
    fontWeight: 600,
    fontSize: 12,
  },
  title: {
    fontSize: 14,
    fontWeight: 600,
    lineHeight: 1.2,
  },
  subheader: {
    fontSize: 12,
    color: '#777',
    lineHeight: 1.3,
  },
  imageContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 14,
  },
  image: {
    width: 52,
    height: 52,
    objectFit: 'contain',
  },
  description: {
    fontSize: 13,
    marginTop: 12,
    color: '#444',
    lineHeight: 1.4,
  },
  estadosContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: 8,
    marginTop: 14,
  },
  estadoActivo: {
    backgroundColor: '#B70E0C',
    width: 24,
    height: 24,
    fontSize: 11,
  },
  estadoInactivo: {
    backgroundColor: '#c5c5c5',
    width: 24,
    height: 24,
    fontSize: 11,
  }
}));

export default function SisefCardSolicitud({
  nombre,
  procesos,
  descripcion,
  imagen,
  codigo_asignatura,
  estados_genericas,
  estado_resumen,
  administrador,
  publicar,
  onPublicar,
  onEliminar,
  onDuplicar,
  onEditar,
  onClick
}) {
  const classes = useStyles();

  const estados = estados_genericas
    .sort((a, b) => a.id - b.id)
    .map((est, index) => {
      const activo = estado_resumen?.[est.codigo] === true;
      return {
        ...est,
        clase: activo ? classes.estadoActivo : classes.estadoInactivo,
        contenido: activo ? <CheckIcon style={{ fontSize: 16 }} /> : index + 1,
      };
    });

  return (
    <Card className={classes.card} elevation={0}>
      {administrador && (
        <div className={classes.toolbar}>
          {publicar == 0 ? (
            <BtnEncender texto="" callback={onPublicar} />
          ) : (
            <BtnApagar texto="" callback={onPublicar} />
          )}
          <BtnEliminar texto="" callback={onEliminar} />
          <BtnDuplicar texto="" color="#B70E0C" callback={onDuplicar} />
          <BtnEditar texto="" color="#B70E0C" callback={onEditar} />
        </div>
      )}
      <div onClick={onClick} style={{ cursor: 'pointer' }}>
        <div className={classes.header}>
          <div className={classes.left}>
            <Avatar className={classes.avatar}>
              {nombre?.charAt(0).toUpperCase()}
            </Avatar>
            <div>
              <Typography className={classes.title}>
                {nombre}
              </Typography>
              <Typography className={classes.subheader}>
                {codigo_asignatura}
                <br />
                {procesos}
              </Typography>
            </div>
          </div>
        </div>
        {imagen && (
          <div className={classes.imageContainer}>
            <img src={imagen} alt="Imagen" className={classes.image} />
          </div>
        )}
        <Typography className={classes.description}>
          {descripcion}
        </Typography>
        <div className={classes.estadosContainer}>
          {estados.map((item, i) => (
            <Tooltip key={i} title={item.nombre}>
              <Avatar className={item.clase}>
                {item.contenido}
              </Avatar>
            </Tooltip>
          ))}
        </div>
      </div>
    </Card>
  );
}
